import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./InterStateOrganisationLicence.module.scss";
import {withRouter} from 'react-router-dom';
import {Button, ErrorMsg, Loading} from "@onegovbugs/onegov-react-components";
import {
    storeSpeciesDetails, 
    fetchSpecies, 
    clearSpeciesSearch} from "../../../redux/actions";
import {
  isCompleted,
  validate,
  scrollToError,
  isNumeric
  } from "../../../utils/Validation";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";  
import SearchIcon from '@material-ui/icons/Search';
import {removeLeadingZeros} from "../../../utils/FormatHelper";

const InterStateOrganisationLicenceForm = (props) => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);


  const invalidSpeciesCodeErrorMessage = 
  'Error: There is an error in your Species Code selection. Please check the Current Species List (link above) to ensure the code is correct and you are eligible to import/export this species.';

  let index = props.match.params.id;

  const speciesDetails = useSelector(state => state.speciesDetails);

  const [speciesList, setSpeciesList] = useState(
    speciesDetails && speciesDetails.speciesList
      ? speciesDetails.speciesList.map((on) => ({ ...on }))
      : []
  );
  
  const editSpecies =
    index && speciesList && speciesList.length > 0
      ? speciesList[index]
      : undefined;

  const dispatch = useDispatch();
  const licenceDetails = useSelector(state => state.licenceDetails);
  const speciesSearchDetails = useSelector(state => state.speciesSearchDetails);
  const oidc = useSelector(state => state.oidc);

  const [hasSpeciesSearchErrorMessage, setHasSpeciesSearchErrorMessage] = useState(false);
  const [speciesCode, setSpeciesCode] = useState(editSpecies ? editSpecies.speciesCode : '');
  const [speciesCommonName, setSpeciesCommonName] = useState(editSpecies ? editSpecies.speciesCommonName :'');
  const [speciesGenus, setSpeciesGenus] = useState(editSpecies ? editSpecies.speciesGenus :'');
  const [species, setSpecies] = useState(editSpecies ? editSpecies.species :'');
  const [subSpecies, setSubSpecies] = useState(editSpecies ? editSpecies.subSpecies :'');
  const [speciesClass, setSpeciesClass] = useState(editSpecies ? editSpecies.speciesClass :'');
  const [atlasId, setAtlasId] = useState(editSpecies ? editSpecies.atlasId :'');
  const [speciesNoOfFauna, setSpeciesNoOfFauna] = useState(editSpecies ? editSpecies.speciesNoOfFauna : '');

  const [showErrors, setShowErrors] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [newAssociate, setNewAssociate] = useState("");

  const validators = [
    {
      fieldName: "speciesCode",
      fieldValue: speciesCode,
      isValid: isCompleted
    },
    {
      fieldName: "speciesCodeValid",
      fieldValue: speciesSearchDetails,
      isValid: (v) => 
      {
        return v && v.searchText !== '' && v.species && v.species.isValid
      }
    },    
    {
      fieldName: "speciesNoOfFauna",
      fieldValue: speciesNoOfFauna,
      isValid:  val => val && val.length >= 1
    },
    {
      fieldName: "speciesNoOfFaunaValid",
      fieldValue: speciesNoOfFauna,
      isValid:  isNumeric
    },
    {
      fieldName: "speciesAlreadyExists",
      fieldValue: speciesList,
      isValid: (v) => 
      {
        if (v && v.length === 0 || index !== undefined) return true;

        return !(v.filter(
           x => x.speciesCode === (
             speciesSearchDetails 
             && speciesSearchDetails.species 
             && speciesSearchDetails.species.speciesCode 
              ? speciesSearchDetails.species.speciesCode 
              : ''
             )
          )[0]);
      }   
    }
  ];
  // useEffect(() => {
  //   validate(validators, setErrors);
  // }, [speciesNoOfFauna, speciesSearchDetails]);

  const [errors, setErrors] = useState({
    speciesCode: false,
    speciesNoOfFauna: false,
    speciesAlreadyExists: false
  });
   

  const searchHandler = () =>  {
    dispatch(fetchSpecies(speciesCode, '', oidc));
  }

  useEffect(() => {

    if(speciesSearchDetails.species === null)
    {
      setHasSpeciesSearchErrorMessage(false);
    } else if(speciesSearchDetails.searchText !== '' && speciesSearchDetails.species && speciesSearchDetails.species.isValid) {
      setHasSpeciesSearchErrorMessage(false);
    } else {
      setHasSpeciesSearchErrorMessage(true);
    } 

    if(speciesSearchDetails.species && speciesSearchDetails.species.isValid)
    {
      setSpeciesCommonName(speciesSearchDetails.species.commonName);
      setSpeciesGenus(speciesSearchDetails.species.genus);
      setSpecies(speciesSearchDetails.species.species);
      setSubSpecies(speciesSearchDetails.species.subspecies);
      setAtlasId(speciesSearchDetails.species.atlasId);
      setSpeciesClass(speciesSearchDetails.species.class);
      setShowSearchResult(true);
    } else  {
      setSpeciesCommonName('');
      setSpeciesGenus('');
      setSpecies('');
      setSubSpecies('');
      setAtlasId('');
      setSpeciesClass('');   
      setShowSearchResult(false);
    }
  }, [speciesSearchDetails]);

  useEffect(() => {
    validate(validators, setErrors);
  }, [
    speciesCode,
    speciesNoOfFauna,
    speciesSearchDetails
  ]);

  useEffect(() => {

    if(editSpecies)
    {
      dispatch(fetchSpecies(speciesCode, '', oidc, validate(validators, setErrors)));
    }


  }, [index]);

  const storeData = () => {
    const newSpeciesDetails = {
      ...speciesDetails,
      speciesList: [
        ...speciesList,
        {
          speciesCode: speciesSearchDetails.species.speciesCode,
          speciesCommonName: speciesSearchDetails.species.commonName,
          speciesGenus: speciesSearchDetails.species.genus,
          species: speciesSearchDetails.species.species,
          subspecies: speciesSearchDetails.species.subspecies,
          speciesNoOfFauna: removeLeadingZeros(speciesNoOfFauna),
          atlasId: speciesSearchDetails.species.atlasId,
          class: speciesSearchDetails.species.class,     
        },
      ],
    };
    dispatch(storeSpeciesDetails(newSpeciesDetails));
  };

  const editData = (speciesHistory) => {
    const newSpeciesDetails = {
      ...speciesDetails,
      speciesList: speciesHistory
    };

    dispatch(storeSpeciesDetails(newSpeciesDetails));
  };

  const saveSpeciesData = () => {
    if (speciesList && speciesList.length > 0) {
      if (index) {
        let updatedSpeciesList = [...speciesList];

        updatedSpeciesList[index] = {
          speciesCode: speciesSearchDetails.species.speciesCode,
          speciesCommonName: speciesSearchDetails.species.commonName,
          speciesGenus: speciesSearchDetails.species.genus,
          species: speciesSearchDetails.species.species,
          subspecies: speciesSearchDetails.species.subspecies,
          speciesNoOfFauna: removeLeadingZeros(speciesNoOfFauna),
          atlasId: speciesSearchDetails.species.atlasId,
          class: speciesSearchDetails.species.class,          
        };
        editData(updatedSpeciesList);
      } else {
        storeData();
      }
    } else {
      storeData();
    }
  };

  return (
    <div className={styles.mainCont}>


        <div className={'row'}>
          <div className={`col-12`}>
            <p>
              Use the <a target="_blank" href="https://www.environment.nsw.gov.au/research-and-publications/publications-search/nsw-native-animal-keepers-species-list">Current Species List</a> to find the Species Code for the animal you are applying to import/export.
              Enter it in the Species Code field, then press the red search button (magnifying glass) to verify it is correct.
              Once the correct species name appears, enter the number of animals to be moved and click Save.
            </p>
            <label htmlFor="inputSpeciesCode" className={styles.title} >
              Species Code            
            </label>            
          </div>
        </div>


        <div className={'row'}>
          <div className={`col-12 col-md-6`}>
            <input
              id={'speciesCodeSearchInput'}
              className={`${styles.formInputBox}`}
              value={speciesCode}
              tabIndex="0"
              onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                  if(speciesCode && speciesCode !== '')
                  {
                    searchHandler();
                  }
                }
              }}
              onChange={async (e) => {
                setSpeciesCode(e.target.value);
              }}
            />
            <div
              className={styles.formButtonDiv}
            >
              <SearchIcon
                tabIndex="0"
                className={styles.formButton}
                onClick={async (e) => {

                  if(speciesCode && speciesCode !== '')
                  {
                    searchHandler();
                  }

                }}
              />
            </div>          
          </div>
          
          {errors.speciesCode && showErrors ? (
            <div className={`col-12`}>
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Species code is required."}
              />
            </div>
          ) : null}

          {errors.speciesCodeValid && !errors.speciesCode && showErrors ? (
            <div className={`col-12`}>
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={invalidSpeciesCodeErrorMessage}
              />
            </div>
          ) : null}

          {!(errors.speciesCodeValid && !errors.speciesCode && showErrors) && hasSpeciesSearchErrorMessage ? (
            <div className={`col-12`}>
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={invalidSpeciesCodeErrorMessage}
              />
            </div>
          ) : null}          

          {errors.speciesAlreadyExists && showErrors ? (
            <div className={`col-12`}>
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Species already exists."}
              />
            </div>
          ) : null}     

      </div>


      {
        speciesSearchDetails.loading &&
        <div className='row'>
          <div className={"col-12"}>
            <Loading
                className={styles.loading}
                label={"Loading..."}
                type={"ajax"}
            />
          </div>
        </div>
      }

      {
        (showSearchResult && !speciesSearchDetails.loading) &&
        <div className={`${styles.searcResult}`}>
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Common Name</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {speciesCommonName}
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Genus</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {speciesGenus}
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Species</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {species}
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Subspecies</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {subSpecies}
                </div>
              </div>
            </div>
      }

      
      <div className={'row'}>
          <div className={`col-12`}>
            <label htmlFor="inputNumberOfFauna" className={styles.title} >
              Number of Fauna
            </label>
          </div>
      </div>



      <div className="row">
        <div className={"col-12 col-md-6"}>
            <input
              id="inputNumberOfFauna"
              className={`${styles.formInputBox}`}
              maxLength="20"
              value={speciesNoOfFauna}
              onChange={event => {
                setSpeciesNoOfFauna(event.target.value);
              }}
            />                      
          </div>   

          {showErrors ? (
              errors.speciesNoOfFauna ? (
                <div className={`col-12`}>
                  <ErrorMsg className={"ErrorMsg_error"}
                    type={"error"}
                    description={"Number of Fauna is required."}
                  />
                </div>

              ) : (errors.speciesNoOfFaunaValid ?
              (
                <div className={`col-12`}>
                  <ErrorMsg
                    type={"error"}
                    description={"Invalid value for Number of Fauna."}
                  />
                </div>
              ) : null)
            ) : null}     

      </div>

      <div className={"row " + styles.buttonCont}>
        <div className={"col-12"}>
          <Button
            onClick={() => {

              setHasSpeciesSearchErrorMessage(false);

              if (validate(validators, setErrors)) {
                saveSpeciesData();
                props.history.push(`/import-export/interstate-organisation-licence`);
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Save
          </Button>
          <Button
            secondary
            onClick={() => {
              setShowErrors(false);
              props.history.push(`/import-export/interstate-organisation-licence`);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>

    </div>
  );
};

export default withRouter(props => <InterStateOrganisationLicenceForm {...props} />);
